import { PlusOutlined } from "@ant-design/icons";
import { Col, Row, Typography } from "antd";
import { MazakaButton } from "apps/Common/MazakaButton";
import StaticPageBanner from "apps/Common/StaticPageBanner";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";

const WhyStore = () => {

  const navigate = useNavigate();
  const {Text} = Typography

  return (
    <>
     
      <Col xs={24} className="!overflow-hidden">
        <Row gutter={[20, 20]}>
          <Col xs={24}>
          <StaticPageBanner
              title= {"Neden Mağaza"}
              description= {"Mağaza açarak daha etkili imkanlara ulaşabilirsiniz."}
            />
                <Helmet>
                                            <title className="capitalize">{"Neden Mağaza"}</title>
                                      </Helmet>
          </Col>
          <Col xs={24} className=" bg-white rounded-lg  !px-4 lg:!px-6 xxl:!px-16">
            <Text className="text-gray-700 ">
              Mağaza üyeliği, kullanıcıların daha fazla imkâna sahip olmasını ve
              platformu daha rahat ve verimli bir şekilde kullanmasını sağlar.
              Standart hesaplara kıyasla, mağaza sahipleri ilanlarını daha geniş
              kitlelere ulaştırabilir, gelişmiş araçlardan faydalanabilir ve
              işletmelerini daha profesyonel bir şekilde yönetebilirler.
            </Text>

            <br />
            <br />
            
            <Text  className="text-lg font-bold ">Mağaza Üyeliğinin Avantajları</Text>
            <ul className="list-disc list-inside text-gray-700 space-y-2 pt-3 pb-3">
              <li>
                <strong>Daha Fazla Görünürlük:</strong> Mağaza hesabı sahipleri,
                ilanlarını öne çıkararak daha fazla kişiye ulaşabilir ve daha
                hızlı satış yapabilir.
              </li>
              <li>
                <strong>Gelişmiş Filtreleme Seçenekleri:</strong> İlanlarınızı
                hedef kitleye uygun şekilde filtreleyerek, en doğru alıcılara
                ulaşabilirsiniz.
              </li>
              <li>
                <strong>Özel Kampanyalara Erişim:</strong> Mağaza üyeleri,
                platform tarafından sunulan özel indirimler, promosyonlar ve
                reklam fırsatlarından yararlanabilir.
              </li>
              <li>
                <strong>Profesyonel Profil Sayfası:</strong> Mağaza sahipleri,
                kendi marka kimliklerini yansıtan bir profil sayfasına sahip
                olur ve müşteri güvenini artırabilir.
              </li>
              <li>
                <strong>Öncelikli Destek:</strong> Mağaza kullanıcıları, teknik
                destek ve müşteri hizmetlerinden öncelikli olarak faydalanarak
                işlemlerini daha hızlı ve sorunsuz bir şekilde
                gerçekleştirebilir.
              </li>
            </ul>

            {/* Mağaza Üyeliğine Nasıl Geçiş Yapabilirsiniz? */}
            <h3 className="text-lg font-bold">
              Mağaza Üyeliğine Nasıl Geçiş Yapabilirsiniz?
            </h3>
             <br />
            <ol className="list-decimal list-inside text-gray-700 space-y-2">
              <li>Hesabınıza giriş yapın.</li>
              <li>
                Profil ayarlarınıza gidin ve "Mağaza Üyeliği" sekmesini seçin.
              </li>
              <li>Sizin için uygun olan mağaza paketini belirleyin.</li>
              <li>
                Ödeme işlemlerini tamamladıktan sonra mağaza avantajlarından
                yararlanmaya başlayın!
              </li>
            </ol>
             <br />
            {/* Sonuç */}
            <p className="text-gray-700">
              Sonuç olarak, mağaza üyeliği, işletmenizi büyütmek ve ilanlarınızı
              daha geniş kitlelere ulaştırmak için harika bir fırsattır. Eğer
              siz de daha fazla imkâna sahip olmak, satışlarınızı artırmak ve
              platformda daha rahat bir deneyim yaşamak istiyorsanız, mağaza
              üyeliğine geçiş yaparak avantajlardan faydalanabilirsiniz.
            </p>
          </Col>

          <Col
            xs={24}
            className="relative z-10 !text-lg !mt-8 flex justify-center"
          >
            <MazakaButton
              onClick={() => {
                navigate("/kurumsal/kayit");
              }}
              icon={<PlusOutlined />}
              className="!bg-black !text-white !p-6"
            >
              Mağaza Aç
            </MazakaButton>
          </Col>
        </Row>
      </Col>
     
    </>
  );
};

export default WhyStore;
